import { useMutation } from '@redwoodjs/web';

import { showErrorToast, showSuccessToast } from 'src/components/Toasts/toast';
import { CREATE_PARTNER_ACCOUNTING_CONNECTION } from 'src/graphql/mutations/partner.mutation';
import { LogError } from 'src/lib';

const useCreatePartnerAccountingConnection = ({
    partnerId,
    onRefetch,
}: {
    partnerId: string;
    onRefetch: () => void;
}) => {
    const [createPartnerAccountingConnection] = useMutation(CREATE_PARTNER_ACCOUNTING_CONNECTION, {
        onError: (error) => {
            showErrorToast(error?.message);
            LogError(error);
        },
        onCompleted: () => {
            showSuccessToast('Partner Sage Connection created!');
            onRefetch();
        },
    });

    const handleCreatePartnerAccountingConnection = () => {
        createPartnerAccountingConnection({
            variables: {
                input: {
                    partnerId,
                },
            },
        });
    };

    return {
        handleCreatePartnerAccountingConnection,
    };
};

export default useCreatePartnerAccountingConnection;
